import { LayoutLoading } from 'components/LayoutLoading'
import { useRef, useState } from 'react'
import EmailEditor, { EditorRef } from 'react-email-editor'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getApplicationEmailTemplateById, submitApplicationEmailTemplate } from 'services'
import { Button } from 'stories/components'

const placeholders = [
  'COMPANY_TITLE',
  'COMPANY_EMAIL',
  'COMPANY_PHONE',
  'COMPANY_ADDRESS',
  'COMPANY_NMLS',
  'WEB_URL',
  'X_LINK',
  'FACEBOOK_LINK',
  'YOUTUBE_LINK',
  'INSTAGRAM_LINK',
  'LINKEDIN_LINK',
  'APPLICATION_LINK',
  'full_name',
]
export default function ApplicationEmailTemplateEditor() {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})
  const emailEditorRef = useRef<EditorRef>(null)

  const urlParams: any = useParams()
  const { id = 0 } = urlParams

  const onLoad = () => {
    setIsLoading(true)
    getApplicationEmailTemplateById(id).then((res) => {
      setData(res)
      if (emailEditorRef.current?.editor) emailEditorRef.current?.editor.loadDesign(res.design)
      setIsLoading(false)
    })
  }

  const onSubmit = async () => {
    setIsLoading(true)
    if (emailEditorRef.current && emailEditorRef.current.editor) {
      emailEditorRef.current.editor.exportHtml((_data) => {
        const { design, html } = _data
        data.design = design
        data.html = html
        submitApplicationEmailTemplate(id, data).then(() => {
          setIsLoading(false)
          toast('Saved successfully.', { type: 'info' })
        })
      })
    } else setIsLoading(true)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />
      <h2 className={`text-2xl font-bold flex items-center mb-4`}>Loan Application Email Template - {data.name}</h2>
      <div className="mb-6">
        <p className="ml-3 text-lg font-medium mb-2">- Placeholders</p>
        <div className="p-3 border rounded-md">
          <div className="flex gap-x-1 gap-y-3 flex-wrap justify-between">
            {placeholders.sort().map((item, index) => {
              return (
                <pre key={index} className="w-[240px] cursor-pointer">
                  {item}
                </pre>
              )
            })}
          </div>
        </div>
      </div>
      <EmailEditor
        ref={emailEditorRef}
        onLoad={onLoad}
        style={{ height: '1200px' }}
        options={{
          features: {
            devTab: false,
            undoRedo: true,
          },
        }}
      />
      <div className="flex justify-center">
        <Button onClick={onSubmit}>Save</Button>
      </div>
    </div>
  )
}
